export default __webpack_public_path__ + "static/media/france.d1cd9006.svg";